const hostname = window.location.hostname;
const stageHostnames = ["localhost", "127.0.0.1"];

const baseMap = {
  "endpoint-gateway-test.finhub.habilelabs.io": "https://backend-test.finhub.habilelabs.io/api", //test
  "customer-vkyc-stage.finhub.habilelabs.io": "https://backend-stage.finhub.habilelabs.io/api",  //stage
  "customer-vkyc.finhub.habilelabs.io": "https://backend-v2.finhub.habilelabs.io/api",           //prod 
};

export const baseURL = stageHostnames.includes(hostname)
  ? "https://backend-test.finhub.habilelabs.io/api"
  : baseMap[hostname] || "https://backend.finhub.habilelabs.io/api";

export const createAuthHeaders = (user) => ({
  Authorization: user?.jwt ? `Bearer ${user.jwt}` : undefined,
});

export const createHeaders = () => {
  return {
    "finhub_api_key": process.env.REACT_APP_API_KEY || '4111598715',
    "api-secret": process.env.REACT_APP_API_SECRET || '8750c397cb1907d8a7d7f319b7e2d740e33810593fd4e16232d033d2076bb18e',
  };
};


 